import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterBetShop from 'views/betShopManagement/betShopCompetence/filterBetShop'; // Importing FilterBetShop component
import TableBetShop from 'views/betShopManagement/betShopCompetence/tableBetShop'; // Importing TableBetShop component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the BetShopView.
 * @extends JetView
 */
export default class BetShopView extends JetView {
    /**
     * Configures the UI components of the BetShopView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for changing page size
                            $$('datatable2').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable2').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable2'); // Reference to datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Competencia'),
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Competencia'),
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Competencia'),
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('datatable2'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Competencia'),
                                        autowidth: true, // Auto width for PDF
                                        ignore: { detailTittle: true }, // Ignore detail title in export
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };
        const left = {
            minWidth: 200,
            cols: [
                {
                    rows: [
                        {
                            view: 'toolbar', // Toolbar for the left section
                            css: theme,
                            elements: [
                                {
                                    view: 'label',
                                    label: _('Puntos de venta Competencia'), // Label for the toolbar
                                },
                                {
                                    type: 'wide',
                                    css: 'close-bottom',
                                    cols: [
                                        {
                                            view: 'icon', // Close icon
                                            icon: 'wxi-close',
                                            bottom: 20,
                                            right: 35,
                                            width: 30,
                                            height: 30,
                                            click: () =>
                                                // Click event to navigate
                                                this.show('/top/dashboard'),
                                        },
                                    ],
                                },
                            ],
                        },
                        FilterBetShop, // Filter component
                        TableBetShop, // Table component
                        toolbar, // Toolbar component
                    ],
                },
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen
        const right = {
            minWidth: 200,
            cols: [
                {
                    rows: [
                        {
                            view: 'yandex-map', // Yandex map component
                            id: 'map',
                            zoom: 12, // Initial zoom level
                            center: [-12.04318, -77.02824], // Initial center coordinates
                            ready: function () {}, // Placeholder for ready event
                        },
                    ],
                },
            ],
        };
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Form view
            scroll: true,
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    height: screen.width < 500 ? 500 : 0, // Responsive height
                    cols: [left, right], // Left and right sections
                },
            ],
        };
    }

    /**
     * Initializes the BetShopView and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        var cthis = this; // Reference to the current instance
        this.on(this.app, 'BetShopMap:reload', (filter) => {
            // Event listener for reloading the map
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for AJAX request
                })
                .post(
                    devConfig.geturlApi() + 'es/BetShop/GetBetShopsCompetenceMap?v=1' + filter, // API endpoint for fetching data
                    '',
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handler
                            webix.message('Error! '); // Display error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handler
                            text = JSON.parse(text); // Parse response
                            var dataf = text.data; // Extract data
                            webix.delay(
                                function () {
                                    $$('map').getMap().geoObjects.removeAll(); // Clear existing map objects
                                    dataf.forEach(function (obj) {
                                        // Iterate over data to add map markers
                                        $$('map')
                                            .getMap()
                                            .geoObjects.add(
                                                new ymaps.Placemark(
                                                    [obj.Latitud, obj.Longitud], // Marker coordinates
                                                    {
                                                        balloonContent:
                                                            '<strong>Competidor: </strong> ' +
                                                            obj.CompetitionName +
                                                            '<br>' +
                                                            '<strong>Nombre: </strong> ' +
                                                            obj.Name +
                                                            '<br>' +
                                                            '<strong>Direccion: </strong> ' +
                                                            obj.Address, // Content for the balloon
                                                    },
                                                    {
                                                        preset: 'islands#icon', // Marker preset
                                                        iconColor: obj.CompetitionColor, // Marker color
                                                    },
                                                ),
                                            );
                                    });
                                },
                                '',
                                '',
                                1000, // Delay before executing the function
                            );
                        },
                    },
                );
        });
        webix.ready(function () {
            // Ready event for Webix
            cthis.app.callEvent('BetShopMap:reload', []); // Trigger reload event
        });
    }
}

// FILE DOCUMENTED
